// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pixel-stream-panel {
  width: 100%;
  min-height: 200px;
  background: #111;
  border-radius: 8px;
  overflow: hidden;
}

.pixel-stream-panel.standby {
  display: grid;
  place-items: center;
  padding: 1rem;
  color: #666;
  font-size: 0.85rem;
  text-align: center;
  border: 1px dashed #ccc;
  background: #fafafa;
}

.pixel-stream-iframe {
  width: 100%;
  height: 220px;
  border: 0;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/PixelStreamPanel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,cAAc;AAChB","sourcesContent":[".pixel-stream-panel {\n  width: 100%;\n  min-height: 200px;\n  background: #111;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pixel-stream-panel.standby {\n  display: grid;\n  place-items: center;\n  padding: 1rem;\n  color: #666;\n  font-size: 0.85rem;\n  text-align: center;\n  border: 1px dashed #ccc;\n  background: #fafafa;\n}\n\n.pixel-stream-iframe {\n  width: 100%;\n  height: 220px;\n  border: 0;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
